export default "__VITE_ASSET__CxLW9gCy__"